import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetOrderQuestionsOrderChangePage } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutChangeOrderCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const globalConfig = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  return (
    <Button<'a'>
      color="secondary"
      href={urlResolverGetOrderQuestionsOrderChangePage(
        globalConfig,
        lastOrder.orderMasterData.orderNumber,
        subOrder.subOrderId,
      )}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="direct.contact.form.change.order" />
    </Button>
  )
}
